module.exports = __webpack_public_path__ + "media/1.238b1d30.wav";